import { render, staticRenderFns } from "./RipaFormWrapper.vue?vue&type=template&id=161d7394"
import script from "./RipaFormWrapper.vue?vue&type=script&lang=js"
export * from "./RipaFormWrapper.vue?vue&type=script&lang=js"
import style0 from "./RipaFormWrapper.vue?vue&type=style&index=0&id=161d7394&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports